import { styled } from '@mui/material/styles'

// Ниже этой ширины меню уходит в выезжающую панель (см. sidebar/styled.js)
export const MOBILE_BREAKPOINT = 899

export const Wrapper = styled('div')`
  display: flex;
  margin-left: 220px;
  width: calc(100% - 220px);
  height: 100vh;
  overflow-y: auto;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin-left: 0;
    width: 100%;
    // dvh, а не vh: на телефоне vh считается вместе с панелью браузера, и
    // низ страницы уезжал бы под вкладки
    height: 100dvh;
    // Сверху панель с названием раздела (52) и вырез экрана, снизу - вкладки (58)
    padding-top: calc(52px + env(safe-area-inset-top, 0px));
    padding-bottom: calc(58px + env(safe-area-inset-bottom, 0px));

    // Страница не должна быть шире экрана: широкая таблица прокручивается
    // сама внутри, а не растягивает всё окно
    // max-height у страниц - расчёт под рабочий стол (100% минус шапка). На
    // телефоне он обрезал содержимое: доска и списки заканчивались на
    // полуслове, хотя ниже были ещё карточки. Страница растёт по содержимому,
    // прокручивается весь экран
    & > * {
      min-width: 0;
      max-width: 100%;
      max-height: none !important;
    }

    // Строка фильтров страницы: на телефоне - одна лента, листается вбок,
    // как панель фильтров в Notion. Столбиком из пяти полей фильтры занимали
    // пол-экрана и отодвигали сам список. Класс вешает страница
    & .filter-strip {
      flex-wrap: nowrap !important;
      align-items: center;
      width: 100% !important;
      margin: 0 !important;
      padding: 8px 16px !important;
      gap: 16px;
      overflow-x: auto;
      scrollbar-width: none;
    }

    & .filter-strip::-webkit-scrollbar {
      display: none;
    }

    & .filter-strip > .MuiGrid-item {
      flex: 0 0 auto !important;
      width: auto !important;
      max-width: none !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    & .filter-strip .MuiTextField-root {
      min-width: 210px;
    }
  }
`
